<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">渠道管理</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="search">查 询</button>
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
          <button class="common-bg-button" @click="handleAddChannel">添加渠道</button>
        </div>
      </div>
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small" placeholder="请输入渠道名称/账号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">创建时间</p>
              <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="createTime" @change="pickCreateTime(createTime)" range-separator="-" start-placeholder="开始时间"
                end-placeholder="结束时间" style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>
      <el-table :data="channelList" size="small" border style="width: 100%">
        <el-table-column prop="activityName" label="关联活动" min-width="140">
          <template slot-scope="{ row }">{{ row.activityName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="channelName" label="渠道名称" min-width="180">
          <template slot-scope="{ row }">{{ row.channelName || row.agentName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="账号(手机号)" min-width="130">
          <template slot-scope="{ row }">{{ row.phone || row.mobile || row.account || '-' }}</template>
        </el-table-column>
        <el-table-column prop="channelLevel" label="渠道级别" min-width="110">
          <template slot-scope="{ row }">
            <span v-if="row.channelLevel || row.agentLevel" class="level-tag"
              :class="getLevelTagClass(row.channelLevel || row.agentLevel)">
              {{ getAgentLevelText(row.channelLevel || row.agentLevel) }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="relationChannel" label="关联渠道" min-width="180">
          <template slot-scope="{ row }">
            <span v-if="(row.childrenCount ?? 0) > 0" class="link-text" @click="handleSubChannelClick(row)">
              ↓下级 {{ row.childrenCount }}个渠道
            </span>
            <span v-else-if="row.parentId" class="link-text" @click="handleParentChannelClick(row)">
              ↑上级
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-switch v-model="row.statusEnabled" :active-value="true" :inactive-value="false"
              @change="handleStatusChange(row)" />
            <span class="status-text">{{ row.statusEnabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qrcode" label="推广二维码" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" icon="el-icon-view" @click="handleViewQrcode(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="registeredCount" label="已报名人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.registeredCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="pendingActivateCount" label="待激活人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.pendingActivateCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="usedCount" label="已使用人数" min-width="110" align="center">
          <template slot-scope="{ row }">{{ row.usedCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="createdWhen" label="创建时间" min-width="170">
          <template slot-scope="{ row }">{{ row.createdWhen || row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>
      <div class="list-pagination">
        <el-pagination background layout="total, prev, pager, next, sizes, jumper" :current-page="pagination.current"
          :page-size="pagination.pageSize" :page-sizes="[10, 20, 50, 100]" :total="pagination.total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>
      <!-- 推广二维码弹窗 -->
      <el-dialog :title="qrcodeDialogTitle" :visible.sync="qrcodeDialogVisible" width="360px" center
        @close="qrcodeDialogVisible = false; qrcodeDataUrl = ''">
        <div class="qrcode-dialog-body" v-if="currentChannel">
          <p class="agent-name">{{ currentChannel.channelName || currentChannel.agentName || '-' }}</p>
          <p class="agent-info-subtitle">
            账号: {{ currentChannel.phone || currentChannel.mobile || currentChannel.account || '-' }} |
            级别: {{ getAgentLevelText(currentChannel.channelLevel || currentChannel.agentLevel) }}
          </p>
          <div class="qrcode-placeholder">
            <img v-if="qrcodeDataUrl" :src="qrcodeDataUrl" class="qrcode-img" alt="推广二维码" />
            <i v-else class="el-icon-picture-outline" style="font-size: 120px; color: #dcdfe6;"></i>
            <p class="qrcode-tip">扫码推广</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDownloadQrcode">下载二维码</el-button>
          <el-button @click="qrcodeDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 添加渠道弹窗 -->
      <el-dialog title="添加渠道" :visible.sync="addChannelDialogVisible" width="550px" center @close="cancelAddChannel">
        <el-form ref="addChannelFormRef" :model="addChannelForm" :rules="addChannelRules" label-width="120px">
          <p class="dialog-description">填写渠道信息，系统将自动生成专属链接</p>
          <el-form-item label="渠道名称" prop="channelName">
            <el-input v-model="addChannelForm.channelName" placeholder="请输入渠道名称" clearable />
          </el-form-item>
          <el-form-item label="账号(手机号)" prop="mobile">
            <el-input v-model="addChannelForm.mobile" placeholder="请输入手机号" clearable maxlength="11" />
          </el-form-item>
          <el-form-item label="代理商级别" prop="agentLevel">
            <el-select v-model="addChannelForm.agentLevel" placeholder="请选择代理商级别" style="width: 100%" clearable
              @change="onAgentLevelChange">
              <el-option label="一级" value="LEVEL_ONE" />
              <el-option label="二级" value="LEVEL_TWO" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="addChannelForm.agentLevel === 'LEVEL_TWO'" label="上级渠道" prop="parentId">
            <el-select v-model="addChannelForm.parentId" placeholder="请选择上级渠道" style="width: 100%" clearable filterable
              :loading="parentChannelLoading">
              <el-option v-for="item in parentChannelOptions" :key="item.id" :label="item.agentName || item.channelName"
                :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddChannel">取 消</el-button>
          <el-button type="primary" @click="confirmAddChannel">确认添加</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

const ACTIVITY_TYPE = "AXB_598_ACTIVITY_PAY";

export default {
  name: "AxbChannelList",
  data() {
    return {
      queryInfo: { keyWord: "", startTime: "", endTime: "", pageNum: 1, pageSize: 10 },
      createTime: [],
      showMultiQuerys: false,
      channelList: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      qrcodeDialogVisible: false,
      currentChannel: null,
      qrcodeDataUrl: "",
      breadCrumb: [
        { name: "营销活动" },
        { name: "安心包598活动" },
        { name: "渠道管理" },
      ],
      addChannelDialogVisible: false,
      addChannelForm: { channelName: "", mobile: "", agentLevel: "", parentId: "" },
      parentChannelOptions: [],
      parentChannelLoading: false,
      addChannelRules: {
        channelName: [
          { required: true, message: "请输入渠道名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
        ],
        agentLevel: [{ required: true, message: "请选择代理商级别", trigger: "change" }],
        parentId: [{ required: true, message: "请选择上级渠道", trigger: "change" }],
      },
    };
  },
  computed: {
    qrcodeDialogTitle() {
      const name = this.currentChannel ? (this.currentChannel.channelName || this.currentChannel.agentName || "-") : "推广";
      return `${name} - 专属二维码`;
    },
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    getListData(pagination, reload = false) {
      const _ = this;
      _.$U.showLoading(_);
      if (reload) { _.pagination.current = 1; _.queryInfo.pageNum = 1; }
      else { _.pagination.current = pagination.current; _.queryInfo.pageNum = pagination.current; }
      _.queryInfo.pageSize = pagination.pageSize;
      const params = {
        activityType: ACTIVITY_TYPE,
        agentLevel: 1,
        keyWord: _.queryInfo.keyWord || undefined,
        startTime: _.queryInfo.startTime || undefined,
        endTime: _.queryInfo.endTime || undefined,
        pageNum: (_.queryInfo.pageNum || 1) - 1,
        pageSize: _.queryInfo.pageSize || 10,
      };
      Object.keys(params).forEach((k) => params[k] === undefined && delete params[k]);
      _.$H.post(_, _.$A.agent.findByPage, params).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const list = payload?.content ?? payload?.list ?? payload?.records ?? [];
        _.channelList = (Array.isArray(list) ? list : []).map((item) => ({
          ...item,
          statusEnabled: item.status === "00" || item.status === "ENABLED" || item.status === 1,
        }));
        _.pagination.total = payload?.totalElements ?? payload?.total ?? 0;
      }).catch(() => { _.channelList = []; _.pagination.total = 0; })
        .finally(() => { _.$U.hideLoading(_); });
    },
    pickCreateTime(time) {
      this.queryInfo.startTime = time && time[0] ? time[0] : "";
      this.queryInfo.endTime = time && time[1] ? time[1] : "";
    },
    toggleFilters() { this.showMultiQuerys = !this.showMultiQuerys; },
    reset() {
      this.queryInfo = { keyWord: "", startTime: "", endTime: "", pageNum: 1, pageSize: 10 };
      this.createTime = [];
      this.getListData(this.pagination, true);
    },
    search() { this.getListData(this.pagination, true); },
    handleCurrentChange(page) { this.pagination.current = page; this.getListData(this.pagination, false); },
    handleSizeChange(size) { this.pagination.pageSize = size; this.pagination.current = 1; this.getListData(this.pagination, true); },
    handleStatusChange(row) {
      const _ = this;
      const newStatus = row.statusEnabled ? "00" : "01";
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.agent.updateAgentStatus, { id: row.id, status: newStatus })
        .then(() => { _.$message.success("状态更新成功"); })
        .catch(() => { row.statusEnabled = !row.statusEnabled; })
        .finally(() => { _.$U.hideLoading(_); });
    },
    handleAddChannel() {
      this.addChannelForm = { channelName: "", mobile: "", agentLevel: "", parentId: "" };
      this.parentChannelOptions = [];
      this.addChannelDialogVisible = true;
      this.$nextTick(() => { this.$refs.addChannelFormRef?.resetFields(); });
    },
    onAgentLevelChange(val) {
      this.addChannelForm.parentId = "";
      if (val === "LEVEL_TWO") {
        this.loadParentChannelOptions();
      } else {
        this.parentChannelOptions = [];
      }
    },
    loadParentChannelOptions() {
      const _ = this;
      _.parentChannelLoading = true;
      _.$H.post(_, _.$A.agent.list, { activityType: ACTIVITY_TYPE, agentLevel: 1 })
        .then((res) => {
          const data = res?.data?.data ?? res?.data ?? [];
          _.parentChannelOptions = Array.isArray(data) ? data : (data?.content ?? data?.list ?? data?.records ?? []);
        })
        .catch(() => { _.parentChannelOptions = []; })
        .finally(() => { _.parentChannelLoading = false; });
    },
    confirmAddChannel() {
      this.$refs.addChannelFormRef.validate((valid) => {
        if (!valid) return;
        const agentLevelMap = { LEVEL_ONE: 1, LEVEL_TWO: 2 };
        const params = {
          agentName: this.addChannelForm.channelName,
          phone: this.addChannelForm.mobile,
          agentLevel: agentLevelMap[this.addChannelForm.agentLevel] || 1,
          activityType: ACTIVITY_TYPE,
        };
        if (this.addChannelForm.agentLevel === "LEVEL_TWO" && this.addChannelForm.parentId) {
          params.parentId = this.addChannelForm.parentId;
        }
        this.$U.showLoading(this);
        this.$H.post(this, this.$A.agent.add, params).then(() => {
          this.$message.success("渠道添加成功");
          this.addChannelDialogVisible = false;
          this.$refs.addChannelFormRef?.resetFields();
          this.getListData(this.pagination, true);
        }).catch(() => { }).finally(() => { this.$U.hideLoading(this); });
      });
    },
    cancelAddChannel() {
      this.addChannelDialogVisible = false;
      this.addChannelForm = { channelName: "", mobile: "", agentLevel: "", parentId: "" };
      this.parentChannelOptions = [];
      this.$refs.addChannelFormRef?.resetFields();
    },
    handleSubChannelClick(row) {
      if (!row.id) { this.$message.warning("该渠道暂无下级数据"); return; }
      this.$router.push({
        name: "axbAgentLevel2List",
        query: { parentId: row.id, parentChannelName: row.agentName || row.channelName },
      });
    },
    handleParentChannelClick(row) {
      if (!row.parentId) { this.$message.warning("该渠道暂无上级数据"); return; }
      // 二级渠道：跳转到同一上级下的二级列表（与空开代理商管理一致）
      this.$router.push({
        name: "axbAgentLevel2List",
        query: { parentId: row.parentId, parentChannelName: row.parentChannelName || row.parentAgentName || "" },
      });
    },
    getPromotionQrcodeUrl(phone) {
      console.log(phone, '22222222222222222222');
      return `alipays://platformapi/startapp?appId=2021006136673279&page=pages/shareIndex/index&query=sharedMerchant%3D${phone || ""}`;
      // return `alipays://platformapi/startapp?appId=2021003146637094&page=pages/activitiesByPopup/index&query=sharedMerchant%3D${phone || ""}`;
    },
    handleViewQrcode(row) {
      this.currentChannel = row; this.qrcodeDataUrl = ""; this.qrcodeDialogVisible = true;
      this.$nextTick(() => this.generateQrcode());
    },
    generateQrcode() {
      if (!this.currentChannel) return;
      const phone = this.currentChannel.phone || this.currentChannel.mobile || this.currentChannel.account || "";
      QRCode.toDataURL(this.getPromotionQrcodeUrl(phone), { width: 200, margin: 2 })
        .then((dataUrl) => { this.qrcodeDataUrl = dataUrl; })
        .catch(() => { this.$message.error("二维码生成失败"); });
    },
    handleDownloadQrcode() {
      if (!this.currentChannel) return;
      const phone = this.currentChannel.phone || this.currentChannel.mobile || this.currentChannel.account || "";
      const name = this.currentChannel.channelName || this.currentChannel.agentName || phone || "channel";
      const fileName = `推广二维码_${String(name).replace(/[/\\?%*:|"<>]/g, "_")}.png`;
      QRCode.toDataURL(this.getPromotionQrcodeUrl(phone), { width: 300, margin: 2 }).then((dataUrl) => {
        const link = document.createElement("a"); link.href = dataUrl; link.download = fileName; link.click();
        this.$message.success("二维码已下载");
      }).catch(() => { this.$message.error("二维码下载失败"); });
    },
    getAgentLevelText(level) {
      const map = { LEVEL_ONE: "一级", LEVEL_TWO: "二级", LEVEL_THREE: "三级", "1": "一级", "2": "二级", "3": "三级", 1: "一级", 2: "二级", 3: "三级" };
      return map[level] || map[String(level)] || level || "-";
    },
    getLevelTagClass(level) {
      const map = { LEVEL_ONE: "level-one", LEVEL_TWO: "level-two", LEVEL_THREE: "level-three", "1": "level-one", "2": "level-two", "3": "level-three", 1: "level-one", 2: "level-two", 3: "level-three" };
      return map[level] || map[String(level)] || "";
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 0;
}

.link-text {
  color: #4182eb;
  cursor: pointer;
}

.status-text {
  margin-left: 8px;
  font-size: 12px;
  color: #606266;
}

.level-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.level-one {
    background: #ecf5ff;
    color: #409eff;
  }

  &.level-two {
    background: #f0f9eb;
    color: #67c23a;
  }

  &.level-three {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

.qrcode-dialog-body {
  text-align: center;
  padding: 16px 0;

  .agent-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #303133;
  }

  .agent-info-subtitle {
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
  }

  .qrcode-placeholder {
    padding: 24px;
    background: #f5f7fa;
    border-radius: 8px;

    .qrcode-img {
      width: 200px;
      height: 200px;
      display: block;
      margin: 0 auto;
    }

    .qrcode-tip {
      margin-top: 12px;
      font-size: 12px;
      color: #909399;
    }
  }
}

.dialog-description {
  text-align: center;
  color: #606266;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
